module.exports = __webpack_public_path__ + "img/monserratgonzalez.5f73cbfb.jpg";